import { Eye, EyeClosed, Key, Mail } from 'lucide-react';
import React, { useState } from 'react'
import { auth, provider } from '../firebase';
import { signInWithEmailAndPassword, signInWithPopup, signOut } from 'firebase/auth';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

export default function Login() {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [passwordVisibility, setPasswordVisibility] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async () => {
        setIsLoading(true);
        try {
            if (email && password) {
                const userCredential = await signInWithEmailAndPassword(auth, email, password);
                // if (!userCredential.user.emailVerified) {
                //     toast.error("Please check the mailbox to verify the email before continue login.")
                //     signOut(auth);
                //     return;
                // } else {
                //     toast.success("Login Successful");
                //     navigate("/home");
                // }
                if(!!userCredential.user) {
                    navigate("/home");
                }
            } else {
                toast.error("Please fill up the form.")
            }
        } catch (error) {
            console.error(error);
            toast.error(`Login Failed`);
        } finally {
            setIsLoading(false);
        }
    };


    const tooglePasswordVisibility = () => {
        setPasswordVisibility(prev => !prev);
    }

    // const handleSignInWithGoogle = async () => {
    //     try {
    //         await signInWithPopup(auth, provider);
    //         toast.success("Login Successful");
    //         navigate("/home");
    //     } catch (error) {
    //         console.error(`Error on login by Google: ${error}`);
    //         toast.error("Login Faild");
    //     }
    // }


    return (
        <div className='page-size flex-center'>
            <div className="flex-center gap-4 min-w-72 p-4">
                <img onClick={() => { navigate("/") }} src="./assets/logo/app.png" alt="app logo" className='w-full max-w-52 py-2 cursor-pointer' />
                <label className="input input-bordered flex items-center gap-2 w-full">
                    <Mail />
                    <input type="text" className="grow" placeholder="Email" value={email} onChange={(e) => { setEmail(e.target.value) }} />
                </label>
                <label className="input input-bordered flex items-center gap-2 w-full pr-0">
                    <Key />
                    <input type={passwordVisibility ? "text" : "password"} className="grow" placeholder='Password' value={password} onChange={(e) => { setPassword(e.target.value) }} />
                    <button className='btn btn-square btn-ghost' onClick={tooglePasswordVisibility}>
                        {
                            passwordVisibility ? <Eye /> : <EyeClosed />
                        }
                    </button>
                </label>
                {/* <div className="self-end">
                    <button className="btn btn-sm btn-ghost underline" onClick={() => navigate("/forget-password")}>
                        Forget Password?
                    </button>
                </div> */}
                <button onClick={handleLogin} className="w-full btn bg-[#00449c] hover:bg-[#3468ab] text-white" disabled={isLoading}>
                    {isLoading ? <span className="loading loading-spinner" /> : "Login"}
                </button>
                {/* <p className='flex justify-center items-center gap-2'>
                    Don't have an account?
                    <button className='btn btn-ghost btn-sm underline' onClick={() => navigate("/sign-up")}>
                        Sign up
                    </button>
                </p>
                <div className="divider">
                    or
                </div>
                <button className="btn btn-outline w-full flex flex-row gap-2 justify-center items-center " onClick={handleSignInWithGoogle}>
                    <img src="/assets/logo/google.svg" className='h-6' alt="gooogle icon" />
                    <p>Sign in with Google</p>
                </button> */}
            </div>

        </div>
    )
}
